import * as React from "react";
import { Grid, Button, Popper, Paper, WithStyles, ClickAwayListener, Fade } from "@material-ui/core";
import SearchListItemPlace from "./search-list-item-place";
import styles from "../../styles/generic/search-dropdown-places";
import { withStyles } from "@material-ui/styles";
import { PlaceByLocality } from "../../types";

/**
 * Component Props
 */
interface Props extends WithStyles<typeof styles> {
  buttonBackgroundColor: string;
  buttonTextColor: string;
  label: string;
  disabled: boolean;
  places: PlaceByLocality[];
  selectedIds: string[];
  onFilterListChange: (keywordId: string, selected: boolean) => void;
}

/**
 * Creates component for changing search parameters for filtter
 *
 * @param props Component props
 */
const SearchDropDownPlaces = (props: Props) => {
  const [anchorEl, setAnchorEl] = React.useState<null | undefined | HTMLElement>(null);
  const gridRef = React.useRef();

  /**
   * Handles click event
   */
  const handleClick = () => {
    setAnchorEl(anchorEl ? null : gridRef.current);
  };

  /**
   * Handles click away event for popper closing it
   */
  const onKeywordListClickAway = () => {
    setAnchorEl(null);
  };

  const open: boolean = Boolean(anchorEl);
  const { classes, onFilterListChange, label, buttonTextColor, buttonBackgroundColor } = props;
  const selectable = props.places.filter(item => props.selectedIds.indexOf(item.address_locality_fi) === -1);

  return (
    <div className={ classes.searchParamContainer }>
      <Grid
        className={ classes.dropdownContainer }
        container
        item
        justify="center"
        direction="column"
        alignItems="stretch"
      >
        <Grid
          container
          alignItems="stretch"
          justify="center"
          className={ classes.buttonContainer }
          innerRef={ gridRef }
        >
          <Button
            style={{ color: buttonTextColor, backgroundColor: buttonBackgroundColor }}
            disableElevation
            variant="contained"
            color="inherit"
            onClick={ handleClick }
            disabled={ props.disabled }
            classes={{ root: classes.buttonRoot, label: classes.buttonLabel }}
          >
            { label }
          </Button>
        </Grid>
      </Grid>

      <Popper open={ open } placement="bottom" anchorEl={ anchorEl } transition>
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={ onKeywordListClickAway }>
            <Fade { ...TransitionProps }>
              <Paper className={ classes.itemList }>
                { selectable.map((item) => {
                  return <SearchListItemPlace place={ item } onChange={ onFilterListChange } key={ item.id } selected={ false } />;
                })}
              </Paper>
            </Fade>
          </ClickAwayListener>
        )}
      </Popper>
    </div>
  );
};

export default withStyles(styles, { withTheme: true })( SearchDropDownPlaces );
